import { CheckInput, ColumnTable } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FinancialBlockProcessItem } from '../api';

const dictPrefix = 'financialPortal.settings.financialBlock';

export function useProcessColumns(): ColumnTable<FinancialBlockProcessItem>[] {
  const { t } = useTranslation();

  return useMemo<ColumnTable<FinancialBlockProcessItem>[]>(
    () => [
      {
        columnName: 'code',
        headerText: t(`${dictPrefix}.columns.process`),
        cellFormat: ({ row }) => t(`${dictPrefix}.processNames.${row.code}`),
      },
      {
        columnName: 'affected',
        headerText: t(`${dictPrefix}.columns.enabled`),
        thClassName: 'text-center',
        tdClassName: 'text-center',
        width: 110,
        // Sólo indicador: la edición vive en el modal. `readOnly` en lugar de
        // `disabled` para que el estado se lea sin el gris de deshabilitado.
        //
        // `label` va vacío a propósito: la columna ya se titula "Habilitado" y
        // repetir el nombre del proceso duplicaría la primera celda. `name` es
        // además el `id` del input, así que lleva el código para no chocar con
        // el del modal ni entre filas.
        cellFormat: ({ row }) => (
          <CheckInput
            name={`process-affected-${row.code}`}
            label=""
            value={row.affected}
            readOnly
          />
        ),
      },
    ],
    [t],
  );
}
